<template>
  <div class="profile-container">
    <va-row :gutter="28">
      <va-column :xs="12" :sm="6" :md="4">
        <div class="profile">
          <div class="avatar">
            <img
                class="rounded-full"
                v-if="userProfile.profilePicture"
                width="80"
                :src="`${backendUrl}${userProfile.profilePicture}`
                "
                alt="User's Profile Picture"
              />
              <avatar
                v-else
                :size="80"
                :username="username"
              ></avatar>
          </div>
          <va-button
            type="subtle"
            size="xs"
            @click.prevent="toggleShowUploadAvatar"
            icon="upload"
            >Unggah Foto</va-button
          >
          <upload-avatar
            field="avatar"
            @crop-success="cropSuccess"
            @crop-upload-success="cropUploadSuccess"
            @crop-upload-fail="cropUploadFail"
            v-model="showUploadAvatar"
            :langExt="langExt"
            :headers="headers"
            :width="300"
            :height="300"
            :url="`${backendUrl}api/user/upload-avatar`"
            langType="en"
            :noSquare="true"
            img-format="png"
            :withCredentials="true"
          ></upload-avatar>
        </div>
      </va-column>
      <va-column :xs="12" :sm="6" :md="6">
        <va-form ref="form" type="vertical">
          <va-form-item label="Nama Depan" need>
            <va-input
              name="namaDepan"
              :rules="[
                { type: 'required', tip: 'Anda harus mengisi kolom ini' },
              ]"
              clearable
              v-model="userData.firstName"
            />
          </va-form-item>
          <va-form-item label="Nama Belakang" need>
            <va-input
              name="namaBelakang"
              :rules="[
                { type: 'required', tip: 'Anda harus mengisi kolom ini' },
              ]"
              clearable
              v-model="userData.lastName"
            />
          </va-form-item>
          <va-form-item label="Jenis Kelamin">
            <va-radio-group :vertical="false" v-model="userData.gender">
              <va-radio-btn label="Laki-Laki" checked>Laki-Laki</va-radio-btn>
              <va-radio-btn label="Perempuan">Perempuan</va-radio-btn>
            </va-radio-group>
          </va-form-item>
          <va-form-item label="Nomor Handphone">
            <va-input
              name="nomor_handphone"
              clearable
              v-model="userData.phoneNumber"
            />
          </va-form-item>
          <va-form-item label="Deskripsi Tentang Anda">
            <va-textarea :resize="true" v-model="userData.description" />
          </va-form-item>
          <va-form-item>
            <va-button type="primary" @click.prevent="saveUserChange"
              >Simpan Perubahan</va-button
            >
            &nbsp;
          </va-form-item>
        </va-form>
      </va-column>
    </va-row>
  </div>
</template>

<script>
// import uploadAvatar from 'vue-image-crop-upload'
import uploadAvatar from 'vue-image-crop-upload/upload-2.vue'
import Avatar from 'vue-avatar'

export default {
  components: {
    'upload-avatar': uploadAvatar,
    Avatar,
  },
  props: {
    userProfile: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      backendUrl: process.env.VUE_APP_BACKEND_URL,
      userData: this.userProfile,
      langExt: {
        hint: 'Tekan atau letakkan file gambar untuk mengunggah...',
        loading: 'Mengunggah…',
        success: 'Sukses mengunggah',
        fail: 'Gagal mengunggah',
        preview: 'Tampilan',
        btn: {
          off: 'Batal',
          close: 'Tutup',
          back: 'Kembali',
          save: 'Simpan',
        },
      },
      // userData: {
      //   firstName: null,
      //   lastName: null,
      //   gender: null,
      //   phoneNumber: null,
      //   profilePicture: null,
      //   profilePictureSmall: null,
      //   description: null,
      // },
      showUploadAvatar: false,
      headers: {
        smail: '*_~',
      },
      imgDataUrl: '',
    }
  },
  methods: {
    // fetchUserData() {
    //   this.$store.dispatch('user/FETCH_USER_DATA')
    //     .then(res => {
    //       // console.log('fetchUserData res =>', res)
    //       const data = res.data
    //       this.userData = { ...this.userData, ...data }
    //     })
    //     .catch(err => {
    //       console.log('fetchUserData err =>', err)
    //     })
    // },
    toggleShowUploadAvatar() {
      this.showUploadAvatar = !this.showUploadAvatar
    },
    cropSuccess(imgDataUrl, field) {
      // console.log(imgDataUrl)
      // this.imgDataUrl = imgDataUrl
    },
    cropUploadSuccess(jsonData, field) {
      console.log('-------- upload success --------')
      const dataCookies = this.$cookies.get('user')
      const newData = {
        ...dataCookies,
        profilePicture: jsonData.data,
      }
      this.$cookies.set('user', newData)
      location.reload()
      // console.log(jsonData)
      this.toggleShowUploadAvatar()
      // console.log(jsonData.data.file)
      // const { id, filepath } = jsonData.data.file
      // this.fetchUserData()
    },
    cropUploadFail(status, field) {
      console.log('-------- upload fail --------')
      console.log(status)
      console.log('field: ' + field)
      this.$emit('fetchUserData')
    },
    saveUserChange() {
      // console.log('saveUserChange =>', this.userData)
      const newUserProfile = this.userData
      this.$store.dispatch('user/UPDATE_USER_PROFILE', { newUserProfile })
        .then(res => {
          // this.fetchUserData()
          const dataCookies = this.$cookies.get('user')
          const newData = {
            ...dataCookies,
            name: this.userData.firstName + ' ' + this.userData.lastName,
          }
          this.$cookies.set('user', newData)
          location.reload()
          if (res.isSuccess) {
            this.notification.success({
              title: 'Sukses',
              message: 'Berhasil Memperbaharui Profil User',
              duration: 3000,
            })
          } else {
            this.notification.error({
              title: 'Error',
              message: 'Gagal Memperbaharui Profil User',
              duration: 3000,
            })
          }
        })
        .catch(err => {
          console.log('saveUserChange err =>', err)
          this.notification.error({
            title: 'Error',
            message: err,
            duration: 3000,
          })
        })
    },
  },
  computed: {
    username() {
      return this.userProfile?.firstName && this.userProfile?.lastName ? this.userProfile.firstName + ' ' + this.userProfile.lastName : '-'
    },
  },
  mounted() {
    // this.fetchUserData()
    this.userData = this.userProfile
  },
}
</script>

<style lang="scss">
.profile-container {
  .profile {
    .vicp-wrap {
      max-width: 600px;
      max-height: 330px;
      width: auto;
      height: auto;
    }
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
  }
}
.avatar {
  width: rem(130);
  height: rem(130);
  border-radius: 50%;
  overflow: hidden;
  background-color: gray;
  text-align: center;
  vertical-align: middle;
}
</style>
